module.exports = __webpack_public_path__ + "static/media/logo@2x.2e8d440e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/logo@2x.png
// module id = 887
// module chunks = 0